import {
    Card,
    Table,
    Paper,
    TableRow,
    TableBody,
    TableCell,
    Typography,
    TableContainer,
    Switch,
    Button,
    alpha,
    IconButton,
} from "@mui/material";
import GoInlineTableHead from "./GoInlineTableHead";
import GoSwitch from "../../components/Inputs/GoSwitch";
import { useEffect, useState } from "react";
import DownloadIcon from "@mui/icons-material/Download"
import Iconify from "../../components/iconify/Iconify";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';


const GoInlineTable = ({
    tableHeads,
    tableDatas,
    onAction = () => { },
    editRowId = null,
    formElement
}) => {
    return (
        <Card>
            <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                    <GoInlineTableHead
                        order={'asc'}
                        orderBy={'id'}
                        headLabel={tableHeads}
                        rowCount={tableDatas.length}
                        numSelected={0}
                    />
                    <TableBody>
                        {tableDatas.length > 0 &&
                            tableDatas.map((row, index) => {
                                return (
                                    (row.rowAction !== undefined && row.rowAction === "new" && formElement) ||
                                    (row.rowAction !== undefined && row.rowAction === "edit" && row.id === editRowId && formElement) ||
                                    <TableRow
                                        hover
                                        key={"row" + row.id}
                                        tabIndex={-1}
                                        role="checkbox"
                                    >
                                        {tableHeads.map((col) => {
                                            return (
                                                <TableCell
                                                    key={"col" + col.id + row.id}
                                                    align={col.align}
                                                >
                                                    {col.type === "text" && row[col.id]}
                                                    {col.type === "number" && row[col.id]}
                                                    {col.type === "date" && row[col.id] !== null && row[col.id] !== undefined &&
                                                        new Date(row[col.id]).toLocaleString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric',
                                                        }).toString().replaceAll(" ", "-")
                                                    }
                                                    {col.type === "switch" && (
                                                        <GoSwitch
                                                            checked={row[col.id]}
                                                            disabled={col.disabled}
                                                            onChange={() => onAction(row, 'switch')}
                                                        />
                                                    )}
                                                    {col.type === "boolean" && row[col.id] && "Yes"}
                                                    {col.type === "boolean" && !row[col.id] && "No"}
                                                    {col.type === "iconbtn" && (
                                                        <Button
                                                            size="small"
                                                            startIcon={<Iconify icon={col.icon} />}

                                                        ></Button>
                                                    )}
                                                    {col.type === "edit" && (
                                                        <Button
                                                            size="small"
                                                            variant="contained"
                                                            startIcon={<EditIcon />}
                                                            sx={{
                                                                bgcolor: (theme) =>
                                                                    alpha(theme.palette.success.dark, 1),
                                                            }}
                                                            onClick={() => onAction(row, 'view')}
                                                        >
                                                            Edit
                                                        </Button>
                                                    )}
                                                    {col.type === "download_btn" && (
                                                        <Button
                                                            size="small"
                                                            variant="contained"
                                                            startIcon={<DownloadIcon />}
                                                            sx={{
                                                                bgcolor: (theme) =>
                                                                    alpha(theme.palette.success.dark, 1),
                                                            }}
                                                            onClick={() => onAction(row, 'download')}
                                                        >
                                                            Download
                                                        </Button>
                                                    )}

                                                    {col.type === "icon_btns" && !row.row_type && (
                                                        <div>
                                                            {
                                                                col.buttons.indexOf("edit") > -1 &&
                                                                <IconButton aria-label="edit" size="small" onClick={() => onAction(row, "edit")} >
                                                                    <EditIcon fontSize="small" color="success" />
                                                                </IconButton>
                                                            }
                                                            {
                                                                col.buttons.indexOf("delete") > -1 &&
                                                                <IconButton aria-label="delete" size="small" onClick={() => onAction(row, "delete")}>
                                                                    <DeleteIcon fontSize="small" color="error" />
                                                                </IconButton>
                                                            }

                                                        </div>
                                                    )}

                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                    {tableDatas.length === 0 && (
                        <TableBody>
                            <TableRow>
                                <TableCell align="center" colSpan={tableHeads.length} sx={{ py: 3 }}>
                                    <Paper
                                        sx={{
                                            textAlign: "center",
                                        }}
                                    >
                                        <Typography variant="h6" paragraph>
                                            No Data Found
                                        </Typography>
                                    </Paper>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    )}
                </Table>
            </TableContainer>
        </Card>
    );
};

export default GoInlineTable;
